import { User, ClipboardList } from "lucide-react";
import { DetailSection } from "@/components/AIAnalysisCard";

const Row = ({ label, children, testId }) => (
  <div className="flex gap-4 border-b py-3 last:border-0 last:pb-0 first:pt-0">
    <dt className="w-24 shrink-0 text-sm text-muted-foreground">{label}</dt>
    <dd className="min-w-0 flex-1 break-words text-sm font-medium text-foreground" data-testid={testId}>{children}</dd>
  </div>
);

export const LeadAnswers = ({ lead }) => (
  <div className="space-y-4" data-testid="lead-answers">
    <DetailSection icon={ClipboardList} title="Project details">
      <p className="whitespace-pre-line text-[15px] leading-relaxed text-foreground" data-testid="lead-description">{lead.description}</p>
      <dl className="mt-4 border-t pt-3">
        <Row label="Size" testId="lead-size">{lead.size}{lead.sqft ? ` · ~${lead.sqft} sq ft` : ""}</Row>
        <Row label="Timeline" testId="lead-timeline">{lead.timeline}</Row>
        <Row label="Budget" testId="lead-budget">{lead.budget || "Not provided"}</Row>
      </dl>
    </DetailSection>
    <DetailSection icon={User} title="Client">
      <dl>
        <Row label="Name">{lead.contact.name}</Row>
        <Row label="Phone" testId="lead-phone">{lead.contact.phone}</Row>
        <Row label="Email" testId="lead-email">{lead.contact.email}</Row>
        <Row label="Location" testId="lead-location">{lead.contact.city}, {lead.contact.zip}</Row>
      </dl>
    </DetailSection>
  </div>
);
